'use es6';

import makeAsyncComponent from 'DesignManagerIde/utils/loadable/makeAsyncComponent';
export const LayoutEditor = makeAsyncComponent(() => import(
/* webpackChunkName: "layout-editor" */
'./containers/LayoutEditor'));
export const LayoutSourceEditor = makeAsyncComponent(() => import(
/* webpackChunkName: "code-editor" */
'./containers/LayoutSourceEditor'));
export const CodeEditorById = makeAsyncComponent(() => import(
/* webpackChunkName: "code-editor" */
'./containers/CodeEditorById'));
export const CodeEditorByPath = makeAsyncComponent(() => import(
/* webpackChunkName: "code-editor" */
'./containers/CodeEditorByPath'));
export const CustomWidgetEditorById = makeAsyncComponent(() => import(
/* webpackChunkName: "custom-widget-editor" */
'./containers/CustomWidgetEditorById'));
export const CustomWidgetEditorByPath = makeAsyncComponent(() => import(
/* webpackChunkName: "custom-widget-editor" */
'./containers/CustomWidgetEditorByPath'));
export const GlobalWidgetEditor = makeAsyncComponent(() => import(
/* webpackChunkName: "custom-widget-editor" */
'./containers/GlobalWidgetEditor'));
export const EmptyState = makeAsyncComponent(() => import(
/* webpackChunkName: "ide-info" */
'./containers/EmptyState'));
export const NotFound = makeAsyncComponent(() => import(
/* webpackChunkName: "ide-info" */
'./components/NotFound'));
export const Welcome = makeAsyncComponent(() => import(
/* webpackChunkName: "ide-info" */
'./containers/Welcome'));
export const GettingStarted = makeAsyncComponent(() => import(
/* webpackChunkName: "getting-started" */
'./components/onboarding/gettingStarted/GettingStarted'));
export const RawAssetEditorById = makeAsyncComponent(() => import(
/* webpackChunkName: "raw-asset-editor" */
'./containers/RawAssetEditorById'));
export const RawAssetEditorByPath = makeAsyncComponent(() => import(
/* webpackChunkName: "raw-asset-editor" */
'./containers/RawAssetEditorByPath'));
export const FolderEditor = makeAsyncComponent(() => import('./containers/FolderEditor'));